import { createFileRoute, Navigate } from '@tanstack/react-router';
import { type ReactElement } from 'react';

import { AgentConfigurationPage } from '@apps/web/components/automations/agent_configuration_page';
import { agentConfigurationSearchSchema } from '@apps/web/components/automations/agent_configuration_search';
import { useSettingsGates } from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/configurations')({
    validateSearch: agentConfigurationSearchSchema,
    head: () => ({
        meta: [{ title: 'Configurations | Phoebe' }],
    }),
    component: ConfigurationsPage,
});

function ConfigurationsPage(): ReactElement | null {
    const { organizationId, isLoading, gates } = useSettingsGates();
    const search = Route.useSearch();
    const navigate = Route.useNavigate();

    if (isLoading) {
        return null;
    }
    if (!gates.canManageOrgSettings || !gates.agentV3) {
        return <Navigate to="/home" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <AgentConfigurationPage
            activeTab={search.tab ?? 'automations'}
            automationId={search.automation_id ?? null}
            organizationId={organizationId}
            onActiveTabChange={(tab) =>
                void navigate({
                    search: (prev) => ({
                        ...prev,
                        tab: tab === 'automations' ? undefined : tab,
                    }),
                })
            }
            onAutomationIdChange={(automationId) =>
                void navigate({
                    search: (prev) => ({
                        ...prev,
                        automation_id: automationId,
                    }),
                })
            }
        />
    );
}
